import { MenuItem, Popover, Stack } from '@mui/material'
import useStyles from './styles'
import React, { useRef, useState } from 'react'
import { ExtraSmallButton } from '../../../custom'

export type StrokeWidthSelectorProps = {
    value: number,
    onChange: (value: number) => void
    compact?: boolean
}

const StrokeWidthSelector: React.FC<StrokeWidthSelectorProps> = ({ value, compact = false, onChange }) => {
    const { classes, cx } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

    const ref = useRef<HTMLDivElement>(null)

    return <div ref={ref}>
        <ExtraSmallButton className={cx(classes.container, {
            [classes.compact]: compact
        })} onClick={() => setAnchorEl(ref.current)}>
            <div className={classes.strokeContainer}>
                <div className={classes.stroke} style={{ height: `${value}px` }} />
            </div>
            <div className={classes.value}>{value}px</div>
        </ExtraSmallButton>
        <Popover
            elevation={3}
            open={Boolean(anchorEl)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            sx={{ display: 'flex', flexDirection: 'column', padding: 1.5, marginTop: 2 }}
        >
            {[1, 2, 3, 4].map((width) => (
                <MenuItem selected={value === width} key={width} onClick={() => {
                    onChange(width)
                    setAnchorEl(null)
                }}>
                    <Stack direction={'row'} gap={1}>
                        <div className={classes.strokeContainer}>
                            <div className={classes.stroke} style={{ height: `${width}px`, width: '18px' }} />
                        </div>
                        <div className={classes.value}>{width}px</div>
                    </Stack>
                </MenuItem>
            ))}
        </Popover>
    </div>
}

export default StrokeWidthSelector

